
































































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import InvoicesInjectorMixin from "@/mixins/invoicesInjectorMixin";
import Context from "@/mixins/context";

// Types
import { IInvoice } from "@/models/invoices";
import { DataModules } from "@/store/modules/data";
import store from "@/store";

@Component({
  components: {
    "invoice-row-item": () =>
      import("@/components/app/global/invoices/invoiceRowItem.vue")
  }
})
export default class InvoicesTableView extends Mixins(
  InvoicesInjectorMixin,
  Context
) {
  // Props

  @Prop({ default: false })
  public isSelectable!: boolean;

  @Prop({ default: () => [] })
  public selectedIds!: IInvoice["id"][];

  @Prop({ default: null })
  public clientId!: IInvoice["client_id"];

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  @Prop({ default: () => (invoice: IInvoice) => ({}) })
  public rowEvents!: (invoice: IInvoice) => Record<string, Function>;

  @Prop({
    default: () => (invoice: IInvoice) => ({
      to: store.getters[`data/${DataModules.INVOICES}/getRoute`](
        invoice.id,
        invoice.client_id
      )
    })
  })
  public rowProps!: (invoice: IInvoice) => Record<string, any>;

  @Prop({ default: false })
  public readonly isSelectedLinked!: boolean;

  // Data

  public selectedInvoiceIds: IInvoice["id"][] = [];
  public allSelectedInvoiceIds = false;

  // Methods

  public selectInvoice(value, isSelected) {
    if (!isSelected) {
      this.$set(
        this,
        "selectedInvoiceIds",
        _.filter(this.selectedInvoiceIds, invoiceId => invoiceId !== value.id)
      );
      return;
    }

    this.selectedInvoiceIds.push(value.id);
  }

  public selectAllInvoiceIds(value) {
    this.$set(
      this,
      "selectedInvoiceIds",
      value ? this.$_.map(this.allAvailableInvoices, invoice => invoice.id) : []
    );
  }

  // Computed

  public get skeletonSize() {
    return this.$store.getters["ui/isMobile"] ? 2 : 5;
  }

  public get showEmptyState() {
    return !this.$invoicesData.isLoading && !this.$invoicesData.total;
  }

  public get showSkeletons() {
    return (
      this.$invoicesData.table.loading ||
      this.$invoicesData.isLoading ||
      !this.$invoicesData.total
    );
  }

  public get allAvailableInvoices() {
    return _.filter(_.cloneDeep(this.$invoicesData.invoices), invoice => {
      return _.isEmpty(invoice.affiliate_commissions);
    });
  }

  // Watch

  @Watch("selectedInvoiceIds")
  public onSelectedInvoiceIdsChange() {
    this.$emit("updateSelectedIds", this.selectedInvoiceIds);
  }

  @Watch("selectedIds")
  public onSelectedIdsChange() {
    this.$set(this, "selectedInvoiceIds", this.selectedIds);
    this.$set(
      this,
      "allSelectedInvoiceIds",
      this.selectedInvoiceIds.length > 0 &&
        this.allAvailableInvoices.length > 0 &&
        this.selectedInvoiceIds.length === this.allAvailableInvoices.length
    );
  }
}
